import { useContext, useEffect, useState } from 'react';
import { StatusCode } from '../assets/constants/constants';
import { AppContext } from '../context/AppProvider';
import { QuarterDetailType } from '../interface';
import { isEnrollmentProgramOpen } from '../lib/utils';
import { getQuaterListDetails } from '../services/quaterdetails';

const useQuaterDetail = () => {
  const [quaterDetails, setData] = useState<QuarterDetailType | null>(null);
  const { state, dispatch} = useContext(AppContext);
  const getQuaterDetails = () => {
    getQuaterListDetails().then((res: any) => {
      if (res.status === StatusCode.SUCCESS) {
        const start = res.data?.currentQuarter.start;
        dispatch({type: 'SET_QUARTER_DETAIL', payload:{enrollmentData:res.data,isEnrollmentOpen:isEnrollmentProgramOpen(start)}});
        setData(res.data);
      }
    });
  };

  useEffect(() => {
    if(state?.user?.userId)
      getQuaterDetails();
  }, [ state?.user?.userId ]);

  return {
    currentQuarter: quaterDetails?.currentQuarter || null,
    nextQuarter: quaterDetails?.nextQuarter || null,
    getQuaterDetails: getQuaterDetails,
  };
};

export default useQuaterDetail;
